import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const FurtherLogoIcon = ({ htmlColor = '#56B26C', ...props }: SvgIconProps) => (
  <SvgIcon viewBox="0 0 23 24" htmlColor={htmlColor} {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.375 9H8.625L0 0H23V24L14.375 15V9Z"
      fill="currentColor"
    />
  </SvgIcon>
);

export default FurtherLogoIcon;
